import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { HIGHLIGHT_CARD_LOADER } from '../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHighlight = styled.div.withConfig({
  displayName: "HighlightCard__StyledHighlight",
  componentId: "gkuws-0"
})(["border-bottom:1px solid ", ";padding:24px 24px 0 24px;"], BATTLESHIP);
const HighlightCard = ({
  children,
  ['data-test-id']: dataTestId,
  errorMessage,
  loading
}) => {
  if (loading) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      "data-test-id": HIGHLIGHT_CARD_LOADER,
      grow: true,
      minHeight: 128
    });
  }
  if (errorMessage) {
    throw new Error(errorMessage);
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(StyledHighlight, {
      children: children
    })
  });
};
export default HighlightCard;